import React from 'react';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.6,
      ease: 'easeOut',
    },
  }),
};

const ContactUs = () => {
  return (
    <div className="min-h-screen bg-white pt-8 md:pt-16 pb-20 px-4 md:px-8 text-blue-900 mt-[7.5rem] mb-[7.5rem] font-lato">
      <div className="max-w-4xl mx-auto text-center">

        <motion.h1
          className="text-5xl font-extrabold mb-8 bg-gradient-to-r from-blue-700 via-purple-600 to-pink-500 text-transparent bg-clip-text"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          Get in Touch with Us
        </motion.h1>

        <motion.p
          className="text-lg font-medium mb-8 max-w-2xl mx-auto"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          custom={1}
        >
          Whether you have questions, need support, or want to plan your next great Himalayan adventure,
          our team is always here to help. Reach out any time!
        </motion.p>

        <motion.div
          className="space-y-8 text-left max-w-md mx-auto"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          custom={2}
        >
          <div className="flex items-center space-x-4">
            <FaPhoneAlt className="text-blue-700 text-xl" />
            <div>
              <h3 className="font-semibold text-lg">Phone</h3>
              <a href="tel:+919883587965" className="text-blue-700 hover:underline text-base">
                +91 98835 87965
              </a>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <FaEnvelope className="text-blue-700 text-xl" />
            <div>
              <h3 className="font-semibold text-lg">Email</h3>
              <a href="mailto:contact@thegreathimalayas.com" className="text-blue-700 hover:underline text-base">
                contact@thegreathimalayas.com
              </a>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <FaMapMarkerAlt className="text-blue-700 text-xl" />
            <div>
              <h3 className="font-semibold text-lg">Address</h3>
              <p className="text-base">
                Siliguri, Darjeeling (Dist), West Bengal, 734001
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <FaClock className="text-blue-700 text-xl" />
            <div>
              <h3 className="font-semibold text-lg">Office Hours</h3>
              <p className="text-base">Monday - Sunday, 9 AM to 6 PM IST</p>
            </div>
          </div>
        </motion.div>

        <motion.p
          className="mt-16 text-xl font-bold"
          custom={7}
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          Your journey is our passion — let's make it unforgettable!
        </motion.p>
      </div>
    </div>
  );
};

export default ContactUs;
